import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import * as i1 from '@ngx-translate/core';
import { TranslatePipe, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

const LANGUAGE_CODE_ENGLISH = 'en';
const LANGUAGE_CODE_FRANCAIS = 'fr';
function httpLoaderFactory(httpClient) {
    return new TranslateHttpLoader(httpClient, './assets/i18n/');
}
class I18nModule {
    constructor(translateService) {
        this.translateService = translateService;
        this.initLanguageTranslation();
    }
    initLanguageTranslation() {
        this.translateService.addLangs([LANGUAGE_CODE_ENGLISH, LANGUAGE_CODE_FRANCAIS]);
        const browserLanguage = this.translateService.getBrowserLang();
        console.log('The browser current language is: ' + browserLanguage);
        let selectedLanguage;
        if (browserLanguage && this.translateService.getLangs().includes(browserLanguage)) {
            selectedLanguage = browserLanguage;
        }
        else {
            selectedLanguage = LANGUAGE_CODE_ENGLISH;
        }
        this.translateService.setDefaultLang(selectedLanguage);
        this.translateService.use(selectedLanguage);
        console.log('The language selected by the library is: ' + selectedLanguage);
    }
    initEnglish() {
        this.translateService.setDefaultLang(LANGUAGE_CODE_ENGLISH);
        this.translateService.use(LANGUAGE_CODE_ENGLISH);
        console.log('The english language was selected explicitly');
    }
    initFrench() {
        this.translateService.setDefaultLang(LANGUAGE_CODE_FRANCAIS);
        this.translateService.use(LANGUAGE_CODE_FRANCAIS);
        console.log('The french language was selected explicitly');
    }
    static { this.ɵfac = function I18nModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || I18nModule)(i0.ɵɵinject(i1.TranslateService)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: I18nModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            TranslatePipe
        ], imports: [TranslateModule.forRoot({
                defaultLanguage: 'en',
                loader: {
                    provide: TranslateLoader,
                    useFactory: httpLoaderFactory,
                    deps: [HttpClient]
                }
            })] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(I18nModule, [{
        type: NgModule,
        args: [{ imports: [TranslateModule.forRoot({
                        defaultLanguage: 'en',
                        loader: {
                            provide: TranslateLoader,
                            useFactory: httpLoaderFactory,
                            deps: [HttpClient]
                        }
                    })], providers: [
                    TranslatePipe
                ] }]
    }], () => [{ type: i1.TranslateService }], null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(I18nModule, { imports: [i1.TranslateModule] }); })();

class LibI18nModule {
    static { this.ɵfac = function LibI18nModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LibI18nModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LibI18nModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [I18nModule,
            TranslateModule, TranslateModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibI18nModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    I18nModule,
                    TranslateModule
                ],
                exports: [
                    TranslateModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibI18nModule, { imports: [I18nModule,
        TranslateModule], exports: [TranslateModule] }); })();

/*
 * Public API Surface of lib-i18n
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibI18nModule };
